export default class Model {

    constructor(params) {

        const {item, appearance} = params;

        if(item) {
            this._id = item.Appearance ? item.Appearance.Id : undefined;
            this._category = item.Category;
            this._weaponType = item.Equipment ? item.Equipment.WeaponType : '';
        } else if(appearance) {
            this._id = appearance.Id;
            this._category = this.getCategory(appearance.Slot);
            this._weaponType = appearance.Type;
        }
    }

    get id() {
        return this._id;
    }

    get category() {
        return this._category;
    }

    get weaponType() {
        return this._weaponType;
    }

    get hasRaceAndGenderModels() {
        return this.category === 'Armor' || this.category === 'Costume';
    }

    getRotationalInformation() {
        let info = {
            x: undefined,
            y: undefined,
            z: undefined,
            rotationObject: undefined
        };

        const toRadians = (angle) => angle * (Math.PI / 180);

        if(this.category === 'Armor' || this.category === 'Costume') {
            info.rotationObject = 'group';
            info.y = 180;
        } else if(this.category === 'Weapon') {
            info.rotationObject = 'mesh';

            if(this.weaponType === 'Shield') {
                info.x = 90;
                info.y = 180;
            } else if(this.weaponType === 'Totem'){
                info.y = 180;
                info.z = 180;
            } else if(this.weaponType === 'Bow') {
                info.x = 90;
            } else if(this.weaponType === 'Gun') {
                info.x = 90;
                info.y = -90;
            } else {
                info.x = 90;
                info.z = 180;
            }
        }

        if(info.x) {
            info.x = toRadians(info.x);
        }

        if(info.y) {
            info.y = toRadians(info.y);
        }

        if(info.z) {
            info.z = toRadians(info.z);
        }

        return info;
    }

    getCategory(slot) {
        return slot === 'One Handed' ||
                slot === 'Two Handed' ||
                slot === 'Main Hand' ||
                slot === 'Ranged' ||
                slot === 'Off Hand' ?
                'Weapon' :
                'Armor';
    }
}


// WEBPACK FOOTER //
// ./src/common/model-viewer/Model.js